import React from 'react';
import Data from '../Data.json';

const BasicInfo = () => {
  return (
    <div className="relative lg:block">
      
      {/* On mobile: inline flow, on lg: absolute */}
      <img
        src="/headshot.jpeg"
        alt={Data.basic_info.name}
        className="w-20 h-20 rounded-full object-cover mb-6 lg:absolute lg:-left-[8.05rem] lg:top-[1.10rem]"
      />

      {/* Text block */}
      <div>
        <h1 className="text-4xl sm:text-5xl font-bold mt-2 sm:mt-3 mb-3 text-black">
          {Data.basic_info.name}
        </h1>
        <h2 className="text-lg sm:text-xl mt-2 mb-4 text-black">{Data.basic_info.byline}</h2>
        <p>{Data.basic_info.bio}</p>
      </div>
    </div>
  );
};

export default BasicInfo;
